import { render, staticRenderFns } from "./SubmitPreview.vue?vue&type=template&id=edbfa822&scoped=true"
import script from "./SubmitPreview.vue?vue&type=script&lang=ts"
export * from "./SubmitPreview.vue?vue&type=script&lang=ts"
import style0 from "./SubmitPreview.vue?vue&type=style&index=0&id=edbfa822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbfa822",
  null
  
)

export default component.exports